const types = {
  FETCH_LOAD_TYPES_START: 'updateConsignment/FETCH_LOAD_TYPES_START',
  FETCH_LOAD_TYPES_SUCCESS: 'updateConsignment/FETCH_LOAD_TYPES_SUCCESS',
  FETCH_CONSIGNMENT_DETAILS_START: 'updateConsignment/FETCH_CONSIGNMENT_DETAILS_START',
  FETCH_CONSIGNMENT_DETAILS_SUCCESS: 'updateConsignment/FETCH_CONSIGNMENT_DETAILS_SUCCESS',
  FETCH_LANES_START: 'updateConsignment/FETCH_LANES_START',
  FETCH_LANES_SUCCESS: 'updateConsignment/FETCH_LANES_SUCCESS',
  UPDATE_CONSIGNMENT: 'updateConsignment/UPDATE_CONSIGNMENT',
  UPDATE_POLYLINE: 'updateConsignment/UPDATE_POLYLINE',
};

export default types;
